import { createApp } from "vue";
import MapSearch from "./mapSearch/MapSearch.vue";

const container = document.getElementById("js-mapSearch");

const app = createApp(MapSearch, {
  formTitle: JSON.parse(container.dataset.formTitle),
  sectionType: container.dataset.sectionType,
  filters: JSON.parse(container.dataset.filters),
});
app.mount(container);
